const HOURS_TO_MINUTES = 60

/**
 * Course chapter theme `hoursTime` from API is stored in minutes (see backend
 * CourseHoursRecalculatorListener / RecalculateCourseHoursCommand).
 * Forms and UI labels use hours.
 */

export function themeMinutesToFormHours(minutes: number): string {
  if (minutes == null || minutes <= 0 || !Number.isFinite(minutes)) {
    return ''
  }
  const hours = minutes / HOURS_TO_MINUTES
  const rounded = Math.round(hours * 100) / 100
  if (rounded === Math.trunc(rounded)) {
    return String(Math.trunc(rounded))
  }
  return String(rounded)
}

export function parseFormHoursToMinutes(
  value: string | undefined
): number | undefined {
  if (value === undefined || value === null) {
    return undefined
  }
  const trimmed = String(value).trim()
  if (trimmed === '') {
    return undefined
  }
  const hours = Number(trimmed.replace(',', '.'))
  if (!Number.isFinite(hours) || hours < 0) {
    return undefined
  }
  return Math.round(hours * HOURS_TO_MINUTES)
}

/** Renders stored minutes as hours for badges and chapter summaries. */
export function formatThemeDurationHours(minutes: number): string {
  if (minutes == null || minutes <= 0 || !Number.isFinite(minutes)) {
    return ''
  }
  const hours = minutes / HOURS_TO_MINUTES
  const formatted =
    hours === Math.trunc(hours)
      ? String(Math.trunc(hours))
      : hours.toLocaleString('ru-RU', {
          maximumFractionDigits: 2,
          minimumFractionDigits: 0,
        })
  return `${formatted} ч.`
}
